import * as z from 'zod';
import { endpoint } from '../http/endpoint';
import {
    CreateRoleAccessRuntype,
    CreateRoleRuntype,
    DeleteRoleAccessRuntype,
    RoleAccessRuntype,
    RoleRuntype,
    UpdateRoleRuntype,
    UserRoleMembershipInsertRuntype,
    UserRoleMembershipRuntype,
} from './roleBackendTypes';

export const roleEndpoints = {
    'GET /roles': endpoint({
        description: 'Get all roles',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.array(RoleRuntype),
    }),

    'POST /roles': endpoint({
        description: 'Create a new role',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: CreateRoleRuntype,
        responseBody: RoleRuntype,
        // Auto-invalidate the roles list after create
        invalidates: ['GET /roles'],
    }),

    'PATCH /roles': endpoint({
        description: 'Update a role',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: UpdateRoleRuntype,
        responseBody: RoleRuntype,
        // Auto-invalidate the roles list after update
        invalidates: ['GET /roles'],
    }),

    'DELETE /roles/:roleId': endpoint({
        description: 'Delete a role by ID',
        pathParams: z.object({
            roleId: z.string(),
        }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.unknown(),
        // Auto-invalidate the roles list after delete
        invalidates: ['GET /roles'],
    }),

    'GET /role_access': endpoint({
        description: 'Get all role access entries',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.array(RoleAccessRuntype),
    }),

    'POST /role_access': endpoint({
        description: 'Create a new role access entry',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: CreateRoleAccessRuntype,
        responseBody: RoleAccessRuntype,
        // Auto-invalidate the role access list after create
        invalidates: ['GET /role_access'],
    }),

    'DELETE /role_access': endpoint({
        description: 'Delete a role access entry',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: DeleteRoleAccessRuntype,
        responseBody: z.unknown(),
        // Auto-invalidate the role access list after delete
        invalidates: ['GET /role_access'],
    }),

    'GET /user_role_memberships': endpoint({
        description: 'Get all user role memberships',
        pathParams: z.undefined(),
        queryParams: z.object({
            user_ids: z.array(z.string()),
        }),
        requestBody: z.undefined(),
        responseBody: z.record(z.string(), z.array(UserRoleMembershipRuntype)),
    }),

    'PATCH /user_role_memberships': endpoint({
        description: 'Update user role memberships',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.object({
            inserts: z.array(UserRoleMembershipInsertRuntype),
            deletes: z.array(UserRoleMembershipInsertRuntype),
        }),
        responseBody: z.array(UserRoleMembershipRuntype),
        // Auto-invalidate the user role memberships list after update
        invalidates: ['GET /user_role_memberships'],
    }),
};
